(function () {
  'use strict';

  /* @ngdoc object
   * @name usuaris.llista
   * @description
   *
   */
  angular
    .module('itecAdministracio.usuaris.main.llista', [
      'ui.router'
    ]);
}());
